export const months = {
	en: [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	],
	hy: [
		'Հունվար',
		'Փետրվար',
		'Մարտ',
		'Ապրիլ',
		'Մայիս',
		'Հունիս',
		'Հուլիս',
		'Օգոստոս',
		'Սեպտեմբեր',
		'Հոկտեմբեր',
		'Նոյեմբեր',
		'Դեկտեմբեր',
	],
	ru: [
		'Январь',
		'Февраль',
		'Март',
		'Апрель',
		'Май',
		'Июнь',
		'Июль',
		'Август',
		'Сентябрь',
		'Октябрь',
		'Ноябрь',
		'Декабрь',
	],
};

export const monthsLabelIds = [
	'FinPathDashboardCartID12',
	'FinPathDashboardCartID13',
	'FinPathDashboardCartID14',
	'FinPathDashboardCartID15',
	'FinPathDashboardCartID16',
	'FinPathDashboardCartID17',
	'FinPathDashboardCartID18',
	'FinPathDashboardCartID19',
	'FinPathDashboardCartID20',
	'FinPathDashboardCartID21',
	'FinPathDashboardCartID22',
	'FinPathDashboardCartID23',
];
